import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const ClasseService = {
  // Récupérer toutes les classes
  async getAllClasses() {
    try {
      const result = await axios.get(`${apiUrl}/Classes`);
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur réseau" };
    }
  },

  // Récupérer une classe par ID
  async getClasseById(id) {
    try {
      const result = await axios.get(`${apiUrl}/classe/${id}`);
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur réseau" };
    }
  },

  // Créer une classe
  async createClasse(data) {
    try {
      const result = await axios.post(`${apiUrl}/Classes/create`, data);
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur lors de la création" };
    }
  },

  // Mettre à jour une classe
  async updateClasse(id, data) {
    try {
      const result = await axios.put(`${apiUrl}/Classes/update/${id}`, data);
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur lors de la mise à jour" };
    }
  },

  // Supprimer une classe
  async deleteClasse(id) {
    try {
      const result = await axios.delete(`${apiUrl}/Classes/delete/${id}`);
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur lors de la suppression" };
    }
  },

  // Récupérer les statistiques d'une classe
  async getClasseStats(id) {
    try {
      const result = await axios.get(`${apiUrl}/Classes/stats/${id}`);
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur lors du chargement des statistiques" };
    }
  },

  // Ajout user dans le classe
  async addUsersToClass(idclasse,data) {
    try {
      const result = await axios.post(`${apiUrl}/Classes/addUsersToClass`, {
        data:data,
        idclasse:idclasse
      });
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur lors de la création" };
    }
  },

  
  // Récupérer les users dans un classe 
  async getClassUsers(id) {
    try {
      const result = await axios.get(`${apiUrl}/Classes/getClassUsers/${id}`);
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur lors du chargement des statistiques" };
    }
  },

   // Supprimer les users dans la classe
  async removeUserFromClass(id,user_id) {
    try {
      const result = await axios.get(`${apiUrl}/Classes/removeUserFromClass/${id}/${user_id}`);
      return result.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Erreur lors du chargement des statistiques" };
    }
  },

  

  
};

export default ClasseService;